import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import useLocale from "../../../hooks/useLocale";
import FormController from "../../ReactHookForm/FormController";
import FormErrorMessageRHF from "../../ReactHookForm/FormErrorMessageRHF";
import FormErrorObserverRHF from "../../ReactHookForm/FormErrorObserverRHF";

/**
 * @param {{
 * nameCountry: string,
 * nameNumber: string,
 * countries: any[],
 * inputProps?: any,
 * placeholder?: string,
 * } & import("@chakra-ui/react").FormControlProps} props
 */
function InputPhone(props) {
  const {
    nameNumber,
    nameCountry,
    countries,
    isRequired,
    inputProps,
    placeholder,
    isDisabled,
    ...otherProps
  } = props;

  const intl = useIntl();

  const { locale } = useLocale();

  return (
    <FormControl
      isRequired={isRequired}
      isDisabled={isDisabled}
      {...otherProps}>
      <FormLabel htmlFor="input-phone-number">
        {intl.formatMessage({
          defaultMessage: "Téléphone",
        })}
      </FormLabel>

      <InputGroup>
        <FormController
          name={nameNumber}
          defaultValue=""
          displayError={false}
          flexGrow={1}
          rules={{ required: isRequired }}
          render={(fields) => (
            <Input
              {...fields}
              id="input-phone-number"
              pl="166px"
              type="tel"
              isDisabled={isDisabled}
              placeholder={
                placeholder ??
                intl.formatMessage({
                  defaultMessage: "Votre téléphone",
                })
              }
              {...inputProps}
            />
          )}
        />

        <InputLeftElement zIndex="auto" w="150px">
          <FormController
            name={nameCountry}
            defaultValue=""
            displayError={false}
            rules={{ required: isRequired }}
            render={(fields) => (
              <Select
                {...fields}
                isDisabled={isDisabled}
                variant="outline"
                borderRightRadius="none"
                borderTop="none"
                borderBottom="none"
                borderLeft="none"
                height="38px">
                <option value="">-</option>

                {countries?.map?.((country) => (
                  <option value={country.iso_code} key={country.id}>
                    {`${locale && country?.name?.[locale]} ${
                      country?.phone_prefixes?.[0]
                    }`}
                  </option>
                ))}
              </Select>
            )}
          />
        </InputLeftElement>
      </InputGroup>

      <FormErrorObserverRHF
        name={nameCountry}
        render={({ error, hasError }) =>
          hasError && <FormErrorMessageRHF error={error} />
        }
      />

      <FormErrorObserverRHF
        name={nameNumber}
        render={({ error, hasError }) =>
          hasError && <FormErrorMessageRHF error={error} />
        }
      />
    </FormControl>
  );
}

InputPhone.propTypes = {
  form: PropTypes.object,
  nameNumber: PropTypes.string,
  nameCountry: PropTypes.string,
  countries: PropTypes.array,
  children: PropTypes.node,
};

InputPhone.defaultProps = {};

export default InputPhone;
